<template>
  <el-dialog :title="$t('shopCommunityManage.settle')" :visible.sync="dialogVisible" width="60%" @close="handleClose">
    <div class="m-t-none m-b">
      <div class="">
        <el-form label-width="120px">
          <el-form-item :label="$t('shopCommunityManage.communityArea')">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-select v-model="addShopCommunityInfo.selectProv"
                  :placeholder="$t('shopCommunityManage.selectProvince')" style="width:100%" @change="getProv">
                  <el-option v-for="item in addShopCommunityInfo.provs" :key="item.areaCode" :label="item.areaName"
                    :value="item.areaCode" />
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-select v-model="addShopCommunityInfo.selectCity" :placeholder="$t('shopCommunityManage.selectCity')"
                  style="width:100%" @change="getCity" :disabled="!addShopCommunityInfo.selectProv">
                  <el-option v-for="item in addShopCommunityInfo.citys" :key="item.areaCode" :label="item.areaName"
                    :value="item.areaCode" />
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-select v-model="addShopCommunityInfo.selectArea"
                  :placeholder="$t('shopCommunityManage.selectDistrict')" style="width:100%" @change="getArea"
                  :disabled="!addShopCommunityInfo.selectCity">
                  <el-option v-for="item in addShopCommunityInfo.areas" :key="item.areaCode" :label="item.areaName"
                    :value="item.areaCode" />
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item :label="$t('shopCommunityManage.community')">
            <el-select v-model="addShopCommunityInfo.communityId"
              :placeholder="$t('shopCommunityManage.selectCommunityRequired')" style="width:100%"
              @change="_changeCommunity">
              <el-option v-for="item in addShopCommunityInfo.communitys" :key="item.communityId" :label="item.name"
                :value="item.communityId" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        <i class="el-icon-close"></i> {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveShopCommunityInfo">
        <i class="el-icon-check"></i> {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { listAreas, queryShopFreeCommunity, saveShopCommunity } from '@/api/goods/shopCommunityApi'

export default {
  name: 'AddShopCommunity',
  data() {
    return {
      dialogVisible: false,
      addShopCommunityInfo: {
        scId: '',
        communityId: '',
        communityName: '',
        cityCode: '',
        areas: [],
        provs: [],
        citys: [],
        selectProv: '',
        selectCity: '',
        selectArea: '',
        address: '',
        codeName: '',
        shopId: '',
        communitys: []
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.addShopCommunityInfo.shopId = getShopId()
      this._initArea('101', '0')
    },
    handleClose() {
      this.clearAddShopCommunityInfo()
    },
    async _initArea(areaLevel, parentAreaCode) {
      try {
        const res = await listAreas({ areaLevel, parentAreaCode })
        if (areaLevel === '101') {
          this.addShopCommunityInfo.provs = res.data
        } else if (areaLevel === '202') {
          this.addShopCommunityInfo.citys = res.data
        } else {
          this.addShopCommunityInfo.areas = res.data
        }
      } catch (error) {
        console.error('获取地区数据失败:', error)
        this.$message.error(this.$t('shopCommunityManage.getAreaFailed'))
      }
    },
    async getProv(prov) {
      this.addShopCommunityInfo.selectCity = ''
      this.addShopCommunityInfo.selectArea = ''
      this.addShopCommunityInfo.citys = []
      this.addShopCommunityInfo.areas = []
      await this._initArea('202', prov)
    },
    async getCity(city) {
      this.addShopCommunityInfo.selectArea = ''
      this.addShopCommunityInfo.areas = []
      await this._initArea('303', city)
    },
    async getArea(area) {
      this.addShopCommunityInfo.cityCode = area
      try {
        const res = await queryShopFreeCommunity({
          shopId: getShopId(),
          page: 1,
          row: 500,
          areaCode: area
        })
        this.addShopCommunityInfo.communitys = res.data
      } catch (error) {
        console.error('查询小区失败:', error)
        this.$message.error(this.$t('shopCommunityManage.queryCommunityFailed'))
      }
    },
    _changeCommunity() {
      if (!this.addShopCommunityInfo.communityId) return

      const selected = this.addShopCommunityInfo.communitys.find(
        item => item.communityId === this.addShopCommunityInfo.communityId
      )
      if (selected) {
        this.addShopCommunityInfo.communityName = selected.name
        this.addShopCommunityInfo.address = selected.address
        this.addShopCommunityInfo.cityCode = selected.areaCode
        this.addShopCommunityInfo.codeName = selected.areaName
      }
    },
    async saveShopCommunityInfo() {
      if (!this.addShopCommunityInfo.communityId) {
        this.$message.warning(this.$t('shopCommunityManage.selectCommunityRequired'))
        return
      }

      try {
        await saveShopCommunity(this.addShopCommunityInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error(error.message || this.$t('common.saveFailed'))
      }
    },
    clearAddShopCommunityInfo() {
      this.addShopCommunityInfo = {
        scId: '',
        communityId: '',
        communityName: '',
        cityCode: '',
        areas: [],
        provs: [],
        citys: [],
        selectProv: '',
        selectCity: '',
        selectArea: '',
        address: '',
        codeName: '',
        shopId: getShopId(),
        communitys: []
      }
    }
  }
}
</script>